import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, inject, signal, effect } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DesyAngularModule } from 'desy-angular';
import { CommonModule } from '@angular/common';
import { uppercaseFirstPipe } from '@/app/pipe/uppercaseFirstPipe.pipe';
import { LoginService } from 'app/services/login.service';
import { UserAnjana } from '@/app/interfaces/UserAnjana';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [DesyAngularModule, CommonModule, uppercaseFirstPipe],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Input() nameUser: string = '';

  isActiveInicio = signal(false);
  isActiveNuevaAdhesion = signal(false);
  isActiveEnviada = signal(false);
  isActiveRecibida = signal(false);
  isActiveCedidos = signal(false);
  isActiveAdheridos = signal(false);
  isActiveProjects = signal(false);
  isActiveSystemIA = signal(false);
  isActiveAiSolutionUsage = signal(false);
  isActiveDataCatalog = signal(false);

  currentUser = signal<Partial<UserAnjana> | null>(null);

  private loginService = inject(LoginService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);

  isLogged = this.loginService.isLogged;
  private onPopState = () => this.updateActiveStates();
  private navigationSubscription = this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe(() => this.updateActiveStates());

  constructor() {}

  userEffect = effect(() => {
    const user = this.loginService.currentUser();
    if (user) {
      const fullName = `${user.givenName ?? ''} ${user.surname1 ?? ''} ${user.surname2 ?? ''}`.trim();
      this.nameUser = fullName;
      this.currentUser.set(user);
    } else {
      this.nameUser = '';
      this.currentUser.set(null);
    }
  });

  ngOnInit() {
    window.addEventListener('popstate', this.onPopState);
    this.updateActiveStates();
  }

  ngOnDestroy() {
    window.removeEventListener('popstate', this.onPopState);
    this.navigationSubscription.unsubscribe();
  }

  logout() {
    this.loginService.logout();
  }

  private updateActiveStates() {
    const url = window.location.pathname;
    this.isActiveInicio.set(url === '/inicio');
    this.isActiveNuevaAdhesion.set(url === '/nueva-adhesion');
    this.isActiveEnviada.set(url === '/mis-adhesiones/listado/enviadas');
    this.isActiveRecibida.set(url === '/mis-adhesiones/listado/recibidas');
    this.isActiveCedidos.set(url === '/uso-datos/cedidos');
    this.isActiveAdheridos.set(url === '/uso-datos/adheridos');
    this.isActiveProjects.set(url === '/catalogo-ia/proyectos/listado-proyectos');
    this.isActiveSystemIA.set(url === '/catalogo-ia/sistemas-de-ia/listado-sistemas');
    this.isActiveAiSolutionUsage.set(url.startsWith('/catalogo-ia/uso-de-solucion-ia/'));
    this.isActiveDataCatalog.set(url === '/catalogo-ia/cambiar-esta-ruta-por-la-que-sea-en-el-futuro');
  }

  get activeInicio() {
    return this.isActiveInicio();
  }
  get activeNuevaAdhesion() {
    return this.isActiveNuevaAdhesion();
  }
  get activeEnviada() {
    return this.isActiveEnviada();
  }
  get activeRecibida() {
    return this.isActiveRecibida();
  }
  get activeCedidos() {
    return this.isActiveCedidos();
  }
  get activeAdheridos() {
    return this.isActiveAdheridos();
  }
  get activeProjects() {
    return this.isActiveProjects();
  }
  get activeSystemIA() {
    return this.isActiveSystemIA();
  }
  get activeAiSolutionUsage() {
    return this.isActiveAiSolutionUsage();
  }
  get activeDataCatalog() {
    return this.isActiveDataCatalog();
  }

  // Metodos para simplificar la tarea de determinar si los dropdowns tienen un item activo
  get isActivePermissionsDropdown() {
    return this.activeEnviada || this.activeRecibida || this.isActiveCedidos() || this.isActiveAdheridos();
  }

  get isActiveCatalogIADropdown() {
    return this.activeProjects || this.activeSystemIA || this.activeAiSolutionUsage;
  }

  get isActiveDataCatalogDropdown() {
    return this.activeDataCatalog; // Aquí añadir los signal de las otras opciones del dropdown de Catálogo de Datos
  }
}
